import { render, staticRenderFns } from "./v-header.vue?vue&type=template&id=e7d7b07e&scoped=true"
import script from "./v-header.vue?vue&type=script&lang=js"
export * from "./v-header.vue?vue&type=script&lang=js"
import style0 from "./v-header.vue?vue&type=style&index=0&id=e7d7b07e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d7b07e",
  null
  
)

export default component.exports